import { createApi } from '@reduxjs/toolkit/query/react';
import axiosBaseQuerySpotfinder from './axiosBaseQuerySpotfinder';
import { spotFinder } from './endpoints';

export const labourReferenceApi = createApi({
  reducerPath: 'labourReferenceApi',
  baseQuery: axiosBaseQuerySpotfinder({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['labourReference'],
  endpoints: (builder) => ({
    getAllLabourReferences: builder.mutation({
      query(body) {
        return {
          url: spotFinder.labourReferenceController.getAllLabourReferences,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),

    getLabourReferenceById: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.labourReferenceController.getLabourReferenceById}${body.payload.id}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),

    getAllLabourReferencesByLabourId: builder.mutation({
      query(body) {
       // console.log("Labour Reference Body:",body);
        return {
          url: `${spotFinder.labourReferenceController.getAllLabourReferencesByLabourId}${body.id}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),

    createLabourReference: builder.mutation({
        query(body) {
          console.log("Update body:",body);
            return {
              url: body.payload.isEdit
                ? `${spotFinder.labourReferenceController.updateLabourReference}${body.payload.id}` 
                : spotFinder.labourReferenceController.createLabourReference, 
              method: body.payload.isEdit ? 'PUT' : 'POST',
              headers: { Authorization: `Bearer ${body.token}` }, 
              body: body.payload, // Pass the payload as the body
            };
          },
      }),
      updateLabourReference: builder.mutation({
      query(body) {
        return {
          url: body.payload.isEdit
            ? `${spotFinder.labourReferenceController.updateLabourReference}${body.payload.id}`
            : spotFinder.labourReferenceController.createLabourReference,
          method: body.payload.isEdit ? 'PUT' : 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    deleteReferences: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.labourReferenceController.deleteReferences}${body.payload.id}`,
          method: 'DELETE',
          headers: { Authorization: `Bearer ${body.token}` },
        };
      },
    }),
  }),
});


export const {
  useGetAllLabourReferencesMutation,
  useGetLabourReferenceByIdMutation,
  useGetAllLabourReferencesByLabourIdMutation,
  useDeleteReferencesMutation,
  useCreateLabourReferenceMutation,
  useUpdateLabourReferenceMutation,
} = labourReferenceApi;
